<section class="c-cover c-cover--basic t-flag-grupo-c3" id="inicio">

  <div class="c-cover__image">
    <!-- <red-marathon-logo class="logo"></red-marathon-logo> -->
    <img src="assets/images/maratona-2025/logo-maratona2025.png"
         alt="logo maratona redação nota 1000"
         class="logo">
  </div>

  <h1 class="c-cover__main-title omega">
    Regulamento Maratona 2025
  </h1>

  <div class="c-cover__content">
    <!--    Última atualização: 28 de setembro de 2021-->

    <ol class="o-list-ordered o-list-ordered--no-indent">
      <li class="o-list-ordered__item c-cover__list-title u-margin-bottom-large">
        <h2>DA CAMPANHA</h2>

        <p class="u-margin-bottom">
          A Campanha de Incentivo “Maratona Redação Nota 1000 - 2025” é instituída,
           neste ato, pela plataforma de correção Redação Nota 1000. Seu objetivo é,
            mediante a distribuição de prêmios, incentivar os participantes a praticarem mais
             a escrita de redação em nível nacional,
           seguindo os critérios definidos no presente regulamento.
        </p>

        <ol class="o-list-ordered">
          <li class="o-list-ordered__item">
            São participantes desta Campanha, única e exclusivamente, 
            alunos de escolas contratantes da Plataforma e alunos de pacotes
             individuais cadastrados na plataforma Redação Nota 1000 que enviarem 
             redações do tema oficial disponibilizado e divulgado pela plataforma para
              cada etapa, respeitando os prazos estabelecidos para cada uma delas. 
          </li>

          <li class="o-list-ordered__item">
            Período de Vigência: Esta Campanha tem início no dia 15/05/2025, às 10h00, e se encerra no dia 30/09/2025, às 23:59 (horário de Brasília). 

            <p class="u-margin-top">
              <strong>Etapa 1:</strong> 
              Início no dia 15/05/2025,
               às 10h00, e encerramento no dia 30/06/2025, às 23:59 (horário de Brasília). 
            </p>

            <p>
              <strong>Etapa 2:</strong> 
               início no dia 15/08/2025, às 10h00,
               e encerramento no dia 30/09/2025, às 23:59 (horário de Brasília).   <br>
               O resultado da Maratona será divulgado na plataforma do Redação Nota 1000
              até dia 15/10/2025, às 18h00. 
            </p>
          </li>

          <li class="o-list-ordered__item">
            As escolas concorrerão na categoria ENEM da Maratona, sendo elas: 

            <ol class="o-list-ordered u-margin-top">
              <li class="o-list-ordered__item">
                Ensino Médio - Para contabilização da premiação, serão consideradas apenas correções das redações feitas por alunos do Ensino Médio e de Pré-Vestibular.
                Outros segmentos poderão participar, porém não serão contabilizados para premiação. 
              </li>
            </ol>

          </li>
 
        </ol>

      </li>

      <li class="o-list-ordered__item c-cover__list-title u-margin-bottom-large">
        <h2>DA DINÂMICA</h2>

        <ol class="o-list-ordered">
          <li class="o-list-ordered__item">
            A participação na Maratona será validada apenas mediante <b>o envio de textos correspondentes 
            aos temas previamente definidos para cada uma das duas etapas,</b>
            utilizando os créditos dos pacotes adquiridos na Plataforma Redação Nota 1000. 
          </li>

          <li class="o-list-ordered__item">
            Para ser elegível em cada etapa, a escola deverá:

            <ol class="o-list-ordered u-margin-top">
              <li class="o-list-ordered__item">
                criar a tarefa no link
                <a href="https://portal.redacaonota1000.com.br/home" target="_blank">https://portal.redacaonota1000.com.br/home</a>,
                com o login e senha de uso na Plataforma;
              </li>

              <li class="o-list-ordered__item">
                Para que a escola seja considerada elegível na Maratona ENEM, 
                o número mínimo de redações enviadas deverá ser equivalente a 30% 
                do total de alunos cadastrados nas turmas de Ensino Médio e Pré-Vestibular.
                 Caso a porcentagem de 30% represente um número inferior a 20 redações, 
                 a escola será elegível apenas se enviar pelo menos 20 redações escritas por 
                 alunos distintos. 
              </li>
            </ol>

          </li>
 
        </ol>
      </li>

      <li class="o-list-ordered__item c-cover__list-title u-margin-bottom-large">
        <h2>DOS CRITÉRIOS DE AVALIAÇÄO</h2>

        <p>
          Participarão nesta Maratona todas as redações enviadas seguindo as regras estipuladas nas categorias de premiação. 
        </p>

        <ol class="o-list-ordered">
          <li class="o-list-ordered__item">
            Critério de avaliação do Ensino Médio (item 1.3.2.): as correções para Ensino Médio seguirão as diretrizes
            do modelo de correção Enem, ambos já utilizados na Plataforma Redação Nota 1000.

            <ol class="o-list-ordered u-margin-top-small">
              <li class="o-list-ordered__item">
                Caso o aluno envie mais de uma redação na mesma etapa, será considerada como elegível a correção com a maior nota; 
              </li>

              <li class="o-list-ordered__item">
                A média final de cada instituição participante será calculada considerando todas as correções elegíveis
                 nas 2 etapas da Maratona no prazo definido. 
              </li>

              <li class="o-list-ordered__item">
                Detalhamento do cálculo para a premiação: para a categoria do Ensino Médio, serão calculadas as médias das 
                notas de todas as redações elegíveis que cumprirem as regras determinadas;
              </li>

              <li class="o-list-ordered__item">
                Critério de desempate entre alunos: ordem de envio (data e hora),
                 em que a redação elegível enviada antes terá melhor classificação.
              </li>

              <li class="o-list-ordered__item">
                Critério de desempate entre escolas: a escola que tiver 
                mais alunos participantes na etapa, terá melhor classificação. 
              </li>
              <li class="o-list-ordered__item">
                É obrigatório o uso dos créditos para correção de redações com nossos corretores especializados Redação Nota 1000. 
              </li>
              <li class="o-list-ordered__item">
                Todas as redações dos participantes da Maratona serão corrigidas por corretores da Redação Nota 1000. Propostas temáticas corrigidas pelos professores da própria escola não serão contabilizadas na Maratona.
               </li>
               <li class="o-list-ordered__item">
                Serão desconsideradas para contabilização na Maratona todas as redações que não forem enviadas no período da etapa vigente e/ou que forem corrigidas por avaliadores fora da equipe Redação Nota 1000.
                 </li>
            </ol>
          </li>
 
        </ol>
      </li>

      <li class="o-list-ordered__item c-cover__list-title u-margin-bottom-large">
        <h2>DA PREMIAÇÃO</h2>

        <p>
          Serão premiadas as três escolas com melhor desempenho mencionadas na cláusula 1.3, sendo atribuídas as posições de 1º, 2º e 3º lugar.
           Cada escola vencedora receberá um troféu com indicação da respectiva colocação. 
           <br>
             Categorias:
            </p>
            <ul>
              <li>Anglo</li>
              <li>Somos - embedadas</li>
              <li>Redação Nota 1000 </li>
            </ul>
         
      </li>

      <li class="o-list-ordered__item c-cover__list-title u-margin-bottom-large">
        <h2>DAS DISPOSIÇÕES GERAIS</h2>
        <ol>
          <li>
            A Maratona Redação Nota 1000 – 2025 
            <br>
            O resultado oficial será divulgado na plataforma Redação Nota 1000, acessível pelo endereço: https://portal.redacaonota1000.com.br. A maratona será divulgada também por meio das plataformas oficiais da Redação Nota 1000,
             nos canais de mídia e comunicação próprios, no ambiente Plurall e pelas escolas parceiras.
          </li>
          <li>
            Os casos omissos neste regulamento serão analisados e resolvidos pela equipe organizadora da Redação Nota 1000, com base nos princípios de equidade, transparência e compromisso pedagógico. 
          </li>

          <li>
            A participação na Maratona implica na aceitação integral deste regulamento, 
            não cabendo questionamentos posteriores quanto às suas condições 
          </li>
        </ol>
        
      </li>

    </ol>

    <h3>TREINE, PARTICIPE E SEJA NOTA 1000! </h3>

  </div>

</section>
